module.exports = __webpack_public_path__ + "media/images/ui__arrowDown-8ebb67dcb505e472426dd41159a50acc.png";